"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPointsBackground = void 0;
const getPointsBackground = ({
  background,
  productPoints,
  userPoints
}) => {
  if (background) {
    return background;
  }
  return productPoints != null && userPoints != null && userPoints >= productPoints ? 'dark' : 'light';
};
exports.getPointsBackground = getPointsBackground;
